<template>
  <div class="languageChanger" :class="{ opened: open }">
    <div class="languageChanger--toggle">
      <div :class="{ open: open }" class="toggle" @click="toggleLangs()"></div>
    </div>
    <div class="languageChanger--langs">
      <span class="currentLanguage" @click="toggleLangs()">
        {{ this.$root.$i18n.locale }}
      </span>
      <ul v-if="open" class="languageSelector" @click="toggleLangs()">
        <li
          class="languageSelector--element"
          v-for="lang in langs"
          :key="`Lang${lang.key}`"
          :value="lang.label"
          @click="changeLocale(lang.key)"
        >
          {{ lang.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageChanger',
  data() {
    return {
      langs: [
        {
          key: 'de',
          label: 'Deutsch'
        },
        {
          key: 'en',
          label: 'English'
        }
      ],
      open: false
    };
  },
  props: { language: String },
  methods: {
    changeLocale(lang) {
      this.$root.$i18n.locale = lang;
    },
    toggleLangs() {
      this.open = !this.open;
    }
  }
};
</script>

<style lang="scss" scoped>
.languageChanger {
  position: absolute;
  top: 10px;
  right: 10px;
  &--toggle {
    cursor: pointer;
  }
}

.currentLanguage,
.languageSelector {
  @include deviceListAddress;
  text-transform: uppercase;
  cursor: pointer;
  color: $greeny-blue;
}

.languageSelector {
  display: block;
  background-color: white;
  border-radius: 5px;
  padding: 0 10px 5px 10px;
  position: absolute;
  // top: 5px;
  top: 45px;
  right: 5px;

  &--element {
    padding: 10px 0;

    &:first-child {
      padding-top: 0;
    }

    &:hover {
      color: $bluey-grey;
      text-decoration: underline;
    }
  }
}

.currentLanguage {
  display: block;
  padding: 5px 10px;
}

.languageChanger {
  display: flex;
  &--toggle {
    display: block;
    width: 10px;
    height: inherit;

    &:before {
      display: block;
      width: 100%;
      content: '';
      margin: 0 0 3px 0;
      transition: background 0.25s ease-out;
    }

    .toggle {
      background: url('../../assets/img/ico-arrow-language-switch.svg') no-repeat center center;
      background-size: contain;
      height: 20px;
      color: $greeny-blue;

      &.open {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
    }
  }
  &--langs {
    width: auto;
  }

  &.opened {
    .languageChanger--langs {
      width: 100px;
    }
  }
}
</style>
